"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonDropdown = void 0;
var React = _interopRequireWildcard(require("react"));
var _Icon = require("../svg/Icon");
var _Button = require("../../components/button/Button");
var _spinner = require("../spinner/spinner");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var upClass = 'toggle-up';
var downClass = 'toggle-down';
var noop = function noop() {};
var ButtonDropdown = /*#__PURE__*/function (_React$Component) {
  _inherits(ButtonDropdown, _React$Component);
  var _super = _createSuper(ButtonDropdown);
  function ButtonDropdown(props) {
    var _this;
    _classCallCheck(this, ButtonDropdown);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "btnRef", /*#__PURE__*/React.createRef());
    _defineProperty(_assertThisInitialized(_this), "btnContainerRef", /*#__PURE__*/React.createRef());
    _defineProperty(_assertThisInitialized(_this), "renderHeader", function () {
      var ButtonProcessingMsg = _this.props.buttonStatus === 'loading' || _this.props.buttonStatus === 'success' ? _this.props.ButtonStatusMsg : '';
      // let ButtonProcessingClass = this.props.buttonStatus === 'loading' || this.props.buttonStatus === 'success' ? 'tl-btn-processing-'+this.props.buttonStatus: '';
      var btnClass = "tl-dropdown-btn dropdown-btn-type2 ";
      var buttonErrorMsg = _this.props.buttonType === "type2" ? /*#__PURE__*/React.createElement("div", {
        className: "tl-buttonType2-err"
      }, _this.props.ButtonStatusMsg) : _this.props.ButtonStatusMsg;
      // ButtonProcessingClass = "tl-dropdown-header "+ ButtonProcessingClass;

      // return ButtonProcessingMsg ? 
      //         <div id={this.props.dropdownId} className={ButtonProcessingClass}> {ButtonProcessingMsg} </div>: 
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        id: _this.props.dropdownId,
        ref: _this.btnRef,
        className: _this.props.buttonType === "type2" ? "tl-dropdown-header tl-ddb-div-type2" : 'tl-dropdown-header',
        onClick: _this.toggleDropdown,
        onFocus: _this.props.onFocus,
        onKeyDown: _this.onKeyDown,
        onMouseOver: _this.props.onMouseOver,
        onMouseOut: _this.props.onMouseOut
      }, _this.getButtonContent(ButtonProcessingMsg, btnClass), _this.props.showSpinner && /*#__PURE__*/React.createElement("span", {
        className: 'tl-bd-spinner'
      }, /*#__PURE__*/React.createElement(_spinner.Spinner, {
        size: "tl-spinner-small"
      }))), !_this.state.isOpen && _this.props.buttonStatus === 'error' && buttonErrorMsg);
    });
    _defineProperty(_assertThisInitialized(_this), "onOptionClick", function (event) {
      var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      if (_this.props.onOptionClick) {
        _this.props.onOptionClick(_this.props.dropdownId, event, option);
      }
      _this.closeDropdown();
    });
    _defineProperty(_assertThisInitialized(_this), "handleClickOutside", function (event) {
      var parentElem = _this.btnContainerRef ? _this.btnContainerRef.current : null;
      if (parentElem && !parentElem.contains(event.target)) {
        _this.iconToggle(null);
        _this.closeDropdown();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onListKeyDown", function (event) {
      // Enter or space selects an option and returns focus to the textbox
      if (event.key === "Enter" || event.key === " " || event.key === "Space") {
        _this.onOptionClick(event);
        var inputElem = document.getElementById(_this.props.dropdownId);
        inputElem !== null && inputElem.focus();
      }
      // Arrow keys navigate through selectable options
      // Up arrow on first option returns focus to the textbox (but doesn't close list)
      if (event.key === "ArrowDown") {
        var targetElem = event.target.nextSibling;
        while (targetElem && targetElem.getAttribute('tabindex') !== '-1') {
          targetElem = targetElem.nextSibling;
        }
        targetElem !== null && targetElem.focus();
      }
      if (event.key === "ArrowUp") {
        var _targetElem = event.target.previousSibling;
        while (_targetElem && _targetElem.getAttribute('tabindex') !== '-1') {
          _targetElem = _targetElem.previousSibling;
        }
        _targetElem !== null && _targetElem.focus();
        if (_targetElem === null) {
          var _inputElem = document.getElementById(_this.props.dropdownId);
          _inputElem !== null && _inputElem.focus();
        }
      }
      // When we tab out, close the dropdown
      if (event.key === "Tab") {
        _this.closeDropdown();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onKeyDown", function (event) {
      if (event.key === "Enter" || event.key === " " || event.key === "Space") {
        _this.setState({
          isOpen: !_this.state.isOpen,
          eventKey: true
        });
      }
      var dropdownContent = document.getElementById(_this.props.dropdownId + "-dropdown-options");
      if (event.key === "ArrowDown" && dropdownContent !== null) {
        var children = dropdownContent.children;
        for (var i = 0; i < children.length; i += 1) {
          if (children[i].getAttribute('tabindex') === '-1') {
            var childElement = document.getElementById(children[i].id);
            childElement !== null && childElement.focus();
            break;
          }
        }
      }
      // When we tab out, close the dropdown
      if (event.key === "Tab") {
        _this.closeDropdown();
      }
      if (_this.props.onKeyDown) {
        _this.props.onKeyDown(event);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "toggleDropdown", function (event) {
      event.stopPropagation();
      event.preventDefault();
      if (_this.props.buttonStatus === 'success' || _this.props.buttonStatus === 'loading') {
        return;
      } else {
        _this.iconToggle(!_this.state.isOpen);
        if (_this.state.eventKey !== true) {
          _this.setState({
            isOpen: !_this.state.isOpen
          });
        }
      }
    });
    _defineProperty(_assertThisInitialized(_this), "closeDropdown", function () {
      if (!_this.props.disabled) {
        if (_this.state.isOpen) {
          _this.setState({
            isOpen: false,
            eventKey: false
          });
        }
      }
    });
    _this.state = {
      isOpen: false,
      eventKey: false
    };
    return _this;
  }
  _createClass(ButtonDropdown, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('mousedown', this.handleClickOutside);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('mousedown', this.handleClickOutside);
    }
  }, {
    key: "getButtonContent",
    value: function getButtonContent(ButtonProcessingMsg, btnClass) {
      var content;
      if (ButtonProcessingMsg) {
        content = /*#__PURE__*/React.createElement("div", {
          className: this.props.buttonStatus === 'success' ? 'tl-ddb-btn-processing-msg tl-ddb-btn-success' : 'tl-ddb-btn-processing-msg'
        }, ButtonProcessingMsg);
      } else if (this.props.buttonType === "type2") {
        content = /*#__PURE__*/React.createElement(_Button.Button, {
          variant: "primary",
          size: "small",
          type: "dropdownButton",
          className: btnClass + ' tl-ddb-type2 '
        }, /*#__PURE__*/React.createElement(_Icon.SvgIcon, {
          name: this.props.label,
          className: "tl-dropdown-icon"
        }));
      } else {
        content = this.props.label;
      }
      return content;
    }
  }, {
    key: "highlightMatch",
    value: function highlightMatch(label, itemId) {
      return /*#__PURE__*/React.createElement("span", {
        id: itemId,
        className: "tl-dropdown-match",
        "data-item": label
      }, label);
    }
  }, {
    key: "renderOptions",
    value: function renderOptions() {
      var _this2 = this;
      return this.props.options.map(function (option) {
        var optionSelected = _this2.props.highlightSelected && _this2.props.value === option.displayText;
        if (option.disabled) {
          return /*#__PURE__*/React.createElement("div", {
            className: "tl-dropdown-disabled-option",
            key: option.itemId,
            id: option.itemId
          }, option.displayText);
        } else if (option.subheader) {
          return /*#__PURE__*/React.createElement("div", {
            className: "tl-dropdown-subheader-option",
            key: option.itemId,
            id: option.itemId
          }, option.displayText);
        } else {
          return /*#__PURE__*/React.createElement(React.Fragment, {
            key: option.itemId
          }, /*#__PURE__*/React.createElement("div", {
            className: "tl-dropdown-option ".concat(_this2.props.optionClassName, " ").concat(optionSelected ? "tl-option-selected" : ''),
            key: "".concat(_this2.props.dropdownId, "-").concat(option.itemId),
            id: "".concat(option.itemId),
            onClick: function onClick(e) {
              return _this2.onOptionClick(e, option);
            },
            onKeyDown: _this2.onListKeyDown,
            tabIndex: -1,
            "data-item": option.itemId
          }, option.icon && /*#__PURE__*/React.createElement(_Icon.SvgIcon, {
            name: option.icon,
            className: "custom-svg-class tl-mr-2"
          }), _this2.highlightMatch(option.displayText, option.itemId), option.iconRight && /*#__PURE__*/React.createElement(_Icon.SvgIcon, {
            name: option.iconRight,
            className: "custom-svg-icon-right-class tl-mr-2"
          })));
        }
      });
    }
  }, {
    key: "iconToggle",
    value: function iconToggle(isOpen) {
      var iconId = '#' + this.props.name + '-svg';
      var className = document.querySelector(iconId);
      if (!this.props.disabled) {
        if (className && className.classList) {
          if (isOpen === null) {
            if (className && className.classList.contains(upClass)) {
              className.classList.replace(upClass, downClass);
            }
          } else {
            if (isOpen) {
              className.classList.replace(downClass, upClass);
            } else {
              className.classList.replace(upClass, downClass);
            }
          }
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props,
        _this$props2,
        _this$props3,
        _this3 = this;
      var renderAbove = false;
      var offsetBottom = this.props.offsetBottom ? this.props.offsetBottom : 0;
      var parentElem = this.btnRef ? this.btnRef.current : null;
      var optionHeight = Math.min(32 + this.props.options.length * 57, 314);
      var dropdownHeight = optionHeight;
      var dropdownClass = this.props.buttonType + '-dd';
      var onButtonFooterClick = (_this$props = this.props) !== null && _this$props !== void 0 && _this$props.onButtonFooterClick ? (_this$props2 = this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.onButtonFooterClick : noop;
      if (parentElem) {
        renderAbove = window.innerHeight - offsetBottom - parentElem.getBoundingClientRect().bottom < dropdownHeight;
      }
      var positionClass = '';
      if ((_this$props3 = this.props) !== null && _this$props3 !== void 0 && _this$props3.position) {
        var _this$props4, _this$props5;
        if (((_this$props4 = this.props) === null || _this$props4 === void 0 ? void 0 : _this$props4.position) === 'left') positionClass = 'tl-dropdown-left';else if (((_this$props5 = this.props) === null || _this$props5 === void 0 ? void 0 : _this$props5.position) === 'right') positionClass = 'tl-dropdown-right';
      }
      return /*#__PURE__*/React.createElement("div", {
        id: "".concat(this.props.dropdownId, "-container"),
        ref: this.btnContainerRef,
        className: "".concat(this.props.className, " ").concat(this.props.showSpinner ? 'tl-button-dropdown-with-loader' : '', " tl-dropdown-button")
      }, this.renderHeader(), !this.props.disabled && /*#__PURE__*/React.createElement("div", {
        id: this.props.dropdownId + "-dropdown-content",
        "data-id": this.props.buttonType,
        className: "".concat(this.props.optionClassName, " ").concat(positionClass, " tl-dropdown-options ").concat(!this.state.isOpen && "tl-dropdown-closed", " ").concat(renderAbove ? 'tl-dropdown-above' : 'tl-dropdown-below', " ").concat(dropdownClass)
      }, /*#__PURE__*/React.createElement("div", {
        id: this.props.dropdownId + "-dropdown-options",
        className: "tl-dropdown-options-list"
      }, this.renderOptions()), this.props.buttonFooterText ? /*#__PURE__*/React.createElement("div", {
        onClick: function onClick(e) {
          onButtonFooterClick(e);
          _this3.closeDropdown();
        },
        className: "tl-button-footer-text text-regular"
      }, this.props.buttonFooterText) : null));
    }
  }]);
  return ButtonDropdown;
}(React.Component);
exports.ButtonDropdown = ButtonDropdown;